ContenedorComentariosDirective.$inject = [];

export default function ContenedorComentariosDirective() {
    return {
        restrict: 'AE',
        scope: {
            'incidenciaId': '='
        },
        template: require('./contenedor-comentarios.html'),
        controller: 'ContenedorComentariosCtrl',
        controllerAs: 'contComent',
        bindToController: true
    }
}